/**
 * KAN-743: режим кабинета организации (estimator | ecommerce) из
 * GET /api/v1/settings/ под общим ключом ['settings'] (как у Источников данных
 * и Настроек). Пока настройки не пришли или недоступны: undefined.
 */
import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/services/api/settings';
import type { OrganizationMode } from '@/types/settings';

function useSettingsQuery() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: settingsApi.getSettings,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function useOrgMode(): OrganizationMode | undefined {
  return useSettingsQuery().data?.organization?.mode;
}

/**
 * KAN-746: режим и признак "настройки ещё грузятся": блок, который выбирается
 * по режиму, не мигает блоком другого режима до ответа.
 */
export function useOrgModeState(): { mode: OrganizationMode | undefined; isLoading: boolean } {
  const query = useSettingsQuery();
  return { mode: query.data?.organization?.mode, isLoading: query.isLoading };
}
